import NextImage from 'next/legacy/image'
import type { FunctionComponent } from 'react'
import { Translation, useTranslate } from '../../contexts/TranslationContext'
import { Button } from '../shared/Button'
import style from './NoOptionsBanner.module.sass'

type NoOptionsBannerProps = {
	openModal: () => void
	title: string
}

export const NoOptionsBanner: FunctionComponent<NoOptionsBannerProps> = ({ openModal, title }) => {
	const translate = useTranslate()

	return (
		<>
			<div className={style.root}>
				<div className={style.content}>
					<div className={style.title}>
						{title}
						<br />
						<Translation tr="noOptionBanner.title.second" />
					</div>
					<div className={style.buttonWrapper}>
						<Button
							label={translate('noOptionBanner.button')}
							type={{ variant: 'underlined', large: true }}
							onClick={openModal}
						/>
					</div>
				</div>
				<div className={style.imageWrapper}>
					<NextImage
						src="/images/empty-bowl.png"
						alt={translate('noOptionBanner.image.alt')}
						title={translate('noOptionBanner.image.alt')}
						layout="fill"
						objectFit="contain"
					/>
				</div>
			</div>
		</>
	)
}
